import type { Tour } from '../tour-types';

/**
 * The survey library. Its empty state (SurveysEmptyState) is marked as a first-run state,
 * so the tour does not start until there is a first survey to list. The row menu step
 * points at the first row's menu only.
 */
export const surveysLibraryTour: Tour = {
  key: 'surveys.library',
  version: 1,
  routes: ['/surveys/library'],
  steps: [
    {
      anchor: 'surveys-library-views',
      placement: 'bottom',
      title: 'Filter by status',
      body: 'Show only running, draft or ended surveys. Archived surveys are left out of All and have a view of their own.',
    },
    {
      anchor: 'surveys-library-search',
      placement: 'bottom',
      title: 'Search',
      body: 'Find a survey by its name within the view you are on.',
    },
    {
      anchor: 'surveys-library-new',
      requires: 'surveys:manage',
      placement: 'left',
      title: 'New survey',
      body: 'Opens the builder: pick NPS, CSAT or CES, edit the questions, then choose when it appears and how it looks.',
    },
    {
      anchor: 'surveys-library-table',
      placement: 'top',
      title: 'Your surveys',
      body: 'Click a name to open the survey, its overview and its results. Click a column title to sort by it.',
    },
    {
      anchor: 'surveys-library-row-actions',
      requires: 'surveys:manage',
      placement: 'left',
      title: 'Row actions',
      body: "Shortcuts to a survey's details, builder and results, and to start, end, duplicate, archive or delete it. A running survey has to be ended before it can be deleted.",
    },
  ],
};
